import(/* webpackMode: "eager" */ "/home/runner/work/granuband-FE/granuband-FE/src/app/page.tsx");
